import {inject, Injectable} from '@angular/core';
import {TranslationApiService} from './translation-api.service';
import {catchError, map, Observable, of} from 'rxjs';
import {TranslocoService} from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private readonly _translationApiService = inject(TranslationApiService);
  private _translocoService = inject(TranslocoService);

  public retrieveAndSetTranslations(): Observable<void> {
    return this._translationApiService.getAvailableLanguages().pipe(
      map((availableLanguages) => this._translocoService.setAvailableLangs(availableLanguages)),
      catchError(() => of(undefined))
    )
  }
}
